import React from 'react'
import { Image, ImageStyle, StyleProp, TouchableOpacity, View } from 'react-native'
import {
  ImageRequestActionSheetOption,
  useImageRequestActionSheet,
} from '@src/hooks/useImageRequestActionSheet'
import { ReactNativeFile } from '@src/utils/image'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon, Text } from '@src/components/base'

interface LabUploadProps {
  onFileChange: (file: ReactNativeFile | undefined) => void
  file: ReactNativeFile | undefined
}

const MIN_IMAGE_HEIGHT = 150

export const LabUpload = (props: LabUploadProps) => {
  const styles = useStyleSheet(themedStyles)
  const { onFileChange, file } = props

  const { showImageRequestActionSheet } = useImageRequestActionSheet(onFileChange)

  const onUploadFilePress = () =>
    showImageRequestActionSheet({
      title: 'Choose Lab Result',
      options: [
        ImageRequestActionSheetOption.ChooseFromLibrary,
        ImageRequestActionSheetOption.TakePhoto,
        ImageRequestActionSheetOption.ChooseFile,
      ],
    })

  if (file) {
    if (file.type && !file.type.startsWith('image/')) {
      return (
        <TouchableOpacity accessibilityLabel="Upload lab result" onPress={onUploadFilePress}>
          <View style={styles.uploadBox}>
            <Icon name="files" style={styles.fileIcon} />
            <Text type="regular">{file.name || 'Selected Document'}</Text>
          </View>
        </TouchableOpacity>
      )
    }

    return (
      <TouchableOpacity accessibilityLabel="Upload lab result" onPress={onUploadFilePress}>
        <View style={styles.uploadBox}>
          <Image
            source={{ uri: file.uri }}
            style={styles.image as StyleProp<ImageStyle>}
            resizeMode="contain"
          />
        </View>
      </TouchableOpacity>
    )
  }

  return (
    <TouchableOpacity accessibilityLabel="Upload lab result" onPress={onUploadFilePress}>
      <View style={styles.uploadBox}>
        <Text type="large">Choose file</Text>
      </View>
    </TouchableOpacity>
  )
}

const themedStyles = StyleService.create({
  uploadBox: {
    borderStyle: 'dashed',
    backgroundColor: 'theme.surface.base3',
    borderColor: 'theme.surface.base1',
    borderRadius: 16,
    borderWidth: 1,
    minHeight: MIN_IMAGE_HEIGHT,
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    minHeight: MIN_IMAGE_HEIGHT,
    marginVertical: 16,
    width: '100%',
  },
  fileIcon: {
    width: 52,
    height: 52,
    marginBottom: 8,
    color: 'theme.primary.base',
  },
})
